// @ts-nocheck
import { FC } from 'react'
import { ColumnInstance } from 'react-table'
import { PartyLedger } from '../core/_models'

type Props = {
  column: ColumnInstance<PartyLedger>;
  selectedRows?: any[];
  rows?: any[];
  handleSelectAll?: () => void;
}

const CustomHeaderColumn: FC<Props> = ({ column, selectedRows, rows, handleSelectAll }) => {
  // Prepare props to pass into custom render function
  const headerProps = {
    selectedRows,
    rows,
    handleSelectAll,
  }

  return (
    <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header',headerProps)
    )}
  </>
  )
}

export { CustomHeaderColumn }



// // @ts-nocheck
// import {FC} from 'react'
// import {ColumnInstance} from 'react-table'
// import {Servicecenter} from '../../core/_models'

// type Props = {
//   column: ColumnInstance<Servicecenter>
// }

// const CustomHeaderColumn: FC<Props> = ({column}) => (
//   <>
//     {column.Header && typeof column.Header === 'string' ? (
//       <th {...column.getHeaderProps()}>{column.render('Header')}</th>
//     ) : (
//       column.render('Header')
//     )}
//   </>
// )

// export {CustomHeaderColumn}